import barba from '@barba/core';

export class WbSearchOverlay {
  constructor() {
    this.init();
  }

  init() {
    this.setProperties();
    this.bindListeners();
  }

  setProperties() {
    this.searchInput = document.querySelector('#wb-search-input');
  }

  bindListeners() {
    const _this = this;

    document
      .querySelector('body')
      ._addCustomEventListener('submit', '#wb-menu-burger__form', _this.onSubmit.bind(_this));

    document.addEventListener('_page_loaded', _this.setProperties.bind(_this));
    document.addEventListener('_page_loaded', _this.resetGlobalSearchValue.bind(_this));
  }

  onSubmit(e) {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);
    const params = new URLSearchParams(formData);
    const action = form.getAttribute('action');

    this.resetGlobalSearchValue();
    barba.go(`${action}?${params.toString()}`);
  }

  resetGlobalSearchValue() {
    const search = document.querySelector('#wb-search-input');
    if (search) search.value = '';
  }
}
